import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'lib-cdw-icon',
    templateUrl: './cdw-icon.component.html',
    styleUrls: ['./cdw-icon.component.scss'],
    standalone: false,
})
export class CdwIconComponent {
  @Input() icon = '';

  @Input() fill = false;

  @Input() useMatIcon = false; // Default to material-symbols-outlined for backward compatibility

  @Input() customColor?: string; // Custom color for the icon

  @Input() outlined = false; // Use material-icons-outlined class when true

  @Input() size?: string; // Custom size for the icon (e.g., '24px', '32px', '2rem')

  @HostBinding('style.width')
  get hostWidth(): string | undefined {
    return this.size;
  }

  @HostBinding('style.height')
  get hostHeight(): string | undefined {
    return this.size;
  }
}
